import React from 'react'
import FormRadioButton from '../../../../library/form/components/FormRadioButton';
import FormROValue from "../../../../library/form/components/FormROValue1"

const RolePrivilegeRecordScopeEditorRow = (props) => {
    const { formObject, rowValueKey } = props;
    
    if( rowValueKey === "docType")
        return(null);

    return (
        <li>
            <div className='uiFlexBox'>
                <div className='uiWidth150'>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: rowValueKey }} />
                </div>
                <FormRadioButton formObject={formObject} rowKey="" text="None" radioKey="none" action={{ paramName: rowValueKey }} />
                <FormRadioButton formObject={formObject} rowKey="" text="Own" radioKey="own" action={{ paramName: rowValueKey }} />
                <FormRadioButton formObject={formObject} rowKey="" text="Group" radioKey="group" action={{ paramName: rowValueKey }} />
                <FormRadioButton formObject={formObject} rowKey="" text="All" radioKey="all" action={{ paramName: rowValueKey }} />
            </div>
        </li>
    )
}

export default RolePrivilegeRecordScopeEditorRow